<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <page-header
      header-title="Sip / VoIP"
      header-content="Crea un inbox de telefonía SIP (Asterisk/PJSIP)."
    />

    <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.channelName.$error }">
          Nombre del inbox
          <input
            v-model.trim="channelName"
            type="text"
            placeholder="Ej. Central Telefónica"
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">Requerido</span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.did.$error }">
          DID / Número del inbox
          <input
            v-model.trim="did"
            type="text"
            placeholder="+51999999999"
            @blur="$v.did.$touch"
          />
          <span v-if="$v.did.$error" class="message">Requerido</span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.sipWsUrl.$error }">
          SIP WS URL (wss)
          <input
            v-model.trim="sipWsUrl"
            type="text"
            placeholder="wss://asterisk.example.com/sip-ws"
            @blur="$v.sipWsUrl.$touch"
          />
          <span v-if="$v.sipWsUrl.$error" class="message">Debe iniciar con ws:// o wss://</span>
        </label>
        <p class="help-text">Endpoint WebSocket SIP expuesto por Asterisk/Nginx.</p>
      </div>

      <div class="w-full">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          button-text="Crear inbox"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

const shouldBeWsUrl = (value = '') =>
  value ? value.startsWith('ws://') || value.startsWith('wss://') : false;

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      did: '',
      sipWsUrl: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    did: { required },
    sipWsUrl: { required, shouldBeWsUrl },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const sipChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          channel: {
            type: 'sip',
            phone_number: this.did,
            sip_ws_url: this.sipWsUrl,
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: sipChannel.id,
          },
        });
      } catch (error) {
        this.showAlert('No se pudo crear el inbox SIP/VoIP');
      }
    },
  },
};
</script>


